const getErrorKeys = (error: any): string[] | null => {
    const keys = error?.error?.response?.data?.validation?.keys;
    if (keys) {
        const allKeys = [].concat(...keys);
        if (!allKeys?.length) {
            return null;
        }
        return allKeys;
    }
    return null;
};

export default getErrorKeys;
